import React from 'react';
import {useTranslation} from "../../hooks/useTranslation";

export function ErrorMessage() {

    const translate = useTranslation();

    return (
        <>
            {translate('error_text')}
        </>
    );
}
